<template>
  <div class="pim">
    <div class="tab-detail">
      <div class="infos">
        <div class="item-infos">
          <alert-message v-if="errorMessageKey" :errorMessageKey="errorMessageKey"
                          :errorClass="errorClass" />
          <div class="info-holder" v-if="info">
            <div class="info-column">
              <section class="info-section">
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.type') }}:</span>
                  <span>{{ info.itemName }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.item-no') }}:</span>
                  <span>{{ info.itemNo }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.serial-no') }}:</span>
                  <span>{{ info.serialNo }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.pa-no') }}:</span>
                  <span>{{ info.paNo }}</span>
                </div>
              </section>
              <section class="info-section">
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.cable-length') }}:</span>
                  <span v-if="info.cableLength">{{ info.cableLength }} m</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.connector1') }}:</span>
                  <span>{{ info.connector1 }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.connector2') }}:</span>
                  <span>{{ info.connector2 }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.cable') }}:</span>
                  <span>{{ info.cableType }}</span>
                </div>
              </section>
            </div>
            <div class="info-column">
              <section class="info-section">
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.date') }}:</span>
                  <span>{{ info.testDate }}</span>
                </div>
              </section>
              <section class="info-section">
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.IM-mode') }}:</span>
                  <span>{{ info.imMode }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.trans-reflection') }}:</span>
                  <span>{{ info.transReflection }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.alarm-level') }}:</span>
                  <span>{{ info.alarmLevel }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.PIM-level-max') }}:</span>
                  <span>{{ info.pimLevelMax }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.sweep-time') }}:</span>
                  <span>{{ info.sweepTime }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.carrier-1') }}:</span>
                  <span>{{ info.carrier1 }}</span>
                </div>
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.carrier-2') }}:</span>
                  <span>{{ info.carrier2 }}</span>
                </div>
              </section>
              <section class="info-section">
                <div class="label-value-entry">
                  <span class="label">{{ $t('hs.att-dashboard.remarks') }}:</span>
                  <span>{{ info.remarks }}</span>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div class="charts full-width">
        <Chart v-if="(labelsPim && dataPointsPim)" :title="pimPass"
               :label="$t('hs.att-dashboard.pim-value')" :labels="labelsPim" :data-points="dataPointsPim"
               x-label="sec" y-label="dB" :alarm-level="alarmLevel"
               :min="-200" :max="-150"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { getResponseFromEntryPoint, createInfoServiceParams, linkEntryPoints } from '@/rest/restClient.js'
  import Chart from '@/components/charts/pim-chart.vue'
  import AlertMessage from '@/components/alert-message'

  export default {
    name: 'pim',
    props: {
      articleNo: {
        type: String,
        required: true
      },
      serialNo: {
        type: String,
        required: true
      }
    },
    components: {
      AlertMessage,
      Chart
    },
    data () {
      return {
        labelsPim: null,
        dataPointsPim: null,
        infoResponse: null,
        pimPass: null,
        errorMessageKey: null,
        errorClass: 'danger'
      }
    },
    methods: {
      async fetchData () {
        const params = createInfoServiceParams(this.articleNo, this.serialNo)
        let datapimChartService = await getResponseFromEntryPoint(linkEntryPoints.pimChartService, params)
        if (!datapimChartService.error) {
          datapimChartService = datapimChartService.props
          this.labelsPim = datapimChartService.xAxis
          this.dataPointsPim = datapimChartService.yAxis
          this.alarmLevel = datapimChartService.alarmLevel
          this.pimPass = datapimChartService.pass
        } else {
          this.labelsPim = null
          this.dataPointsPim = null
          this.alarmLevel = null
          this.pimPass = null
        }

        const result = await getResponseFromEntryPoint(linkEntryPoints.pimInfoService, params)
        if (!result.error) {
          this.infoResponse = result
          this.$emit('success:api', result)
        } else {
          this.infoResponse = null
          this.$emit('error:api', result.error)
        }
      }
    },
    created () {
      if (this.articleNo && this.serialNo) {
        this.fetchData()
      }
      this.$watch(vm => [vm.articleNo, vm.serialNo].join(), this.fetchData)
    },
    computed: {
      info () {
        return this.infoResponse ? this.infoResponse.props : null
      }
    }
  }
</script>

<style lang="scss" scoped>

.infos {
  display: flex;
  padding-bottom: $component-padding;
  flex-wrap: wrap;
}

.chart {
  width: 100%;
}

.full-width {
  width: 100%;
}

.item-infos {
  width: 100%;
}

.label {
  min-width: 50%;
  font-weight: bold;
}

.label-value-entry {
  display: flex;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.info-column {
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
}

.info-holder {
  flex-direction: column;
}

@media only screen and (min-width: $screen-sm-min) {
  .info-holder {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-left: -1rem;
    margin-right: -1rem;
    flex-direction: row;
  }

  .full-width {
    width: calc((100% + 1rem) / 2 * 3);
  }
}

@media only screen and (min-width: $screen-md-min) {
  .full-width {
    width: calc((100% + 1rem) / 3 * 4);
  }
}

</style>
